// src/components/common/RejectButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@/icons';
import './RejectButton.css';

interface RejectButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const RejectButton: React.FC<RejectButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`reject-button ${className}`}
    >
      <FontAwesomeIcon icon={faBan} /> Reprovar
    </button>
  );
};

export default RejectButton;
